/**
 * DisplayInstruments - the display's two small instruments over the map (plan design-gaps, Z6; the session pages).
 *
 * The compass at the top of the instruments' column on the map's right edge, its needle turned to where north lies
 * on this screen (engine/display/compass) as the camera turns; the camera label under it, above the Follow button,
 * naming the shot this screen took (ESTABLISHING, TWO-SHOT, OVER THE SHOULDER, LONG SHOT, YOUR CAMERA). Neither
 * takes the pointer. The column is a flow in the map's bottom layer (PanelBottomLayer), never placed by coordinates.
 *
 * @param {object} props
 * @param {object} props.camera - the scene's camera
 * @param {string|null} props.label - useDisplayCamera's `shot`; none where the camera does not follow
 * @param {import('react').ReactNode} [props.children] - what stands between the compass and the label (the last turn)
 */
import { memo } from 'react';
import { northOnScreen } from '../../engine/display/compass';
import styles from '../../styles/Display.module.css';

/** Memoized: the panel re-renders far more often than its camera moves. */
export default memo(function DisplayInstruments({ camera, label, children }) {
  const north = northOnScreen(camera);
  return (
    <>
      <svg className={styles.compass} viewBox="0 0 34 34" aria-hidden="true" data-testid="display-compass">
        <circle cx={17} cy={17} r={15} />
        <g data-testid="compass-needle" data-north={Math.round(north)} transform={`rotate(${north.toFixed(1)} 17 17)`}>
          <path className={styles.compassNorth} d="M17 4 L20 17 L17 15 L14 17 Z" />
          <path className={styles.compassSouth} d="M17 30 L20 17 L17 19 L14 17 Z" />
          <text x={17} y={10.5}>
            N
          </text>
        </g>
      </svg>
      {children}
      {label && (
        <div className={styles.cameraLabel} data-testid="camera-label">
          {label}
        </div>
      )}
    </>
  );
});
